import AnimationAiAgentsV2 from '@/components/_rebrand/AnimationAiAgentsV2';
import AnimationInsights from '@/components/_rebrand/AnimationInsights';
import AnimationSharedInbox from '@/components/_rebrand/AnimationSharedInbox';
import AnimationTicketing from '@/components/_rebrand/AnimationTicketing';
import AnimationWorkflows from '@/components/_rebrand/AnimationWorkflows';
import IconFeatureInsightful from '@/components/_rebrand/icons/IconFeatureInsightful';
import IconFeatureIntuitive from '@/components/_rebrand/icons/IconFeatureIntuitive';
import IconFeatureScalable from '@/components/_rebrand/icons/IconFeatureScalable';
import IconFeatureUnified from '@/components/_rebrand/icons/IconFeatureUnified';
import { UseCaseAwardsProps } from '@/components/_rebrand/UseCaseAwards';
import { UseCaseFeatureCarouselProps } from '@/components/_rebrand/UseCaseFeatureCarousel';
import { UseCaseFeatureGridProps } from '@/components/_rebrand/UseCaseFeatureGrid';
import { UseCaseIntegrationsProps } from '@/components/_rebrand/UseCaseIntegrations';
import { UseCaseIntelligenceProps } from '@/components/_rebrand/UseCaseIntelligence';
import Image from 'next/image';

export const FEATURE_CAROUSEL_PROPS = {
  title: 'Make five-star service a reality',
  description:
    'Front’s powerful workspace helps teammates collaborate—supported by AI—across your customer’s entire experience. Exceed expectations for speed, ease, and quality.',
  features: [
    {
      icon: <IconFeatureIntuitive className="block w-3 h-3" />,
      title: 'Intuitive',
      image: <Image src="https://front.com/webassets/rebrand/usecase-client-comm-intuitive.png" width={1300} height={733} alt="Front Collaboration" quality={100} />,
    },
    {
      icon: <IconFeatureUnified className="block w-3 h-3" />,
      title: 'Unified',
      image: <Image src="https://front.com/webassets/rebrand/use-case-agent-productivity-static.png" width={1300} height={733} alt="Front Agent Productivity" quality={100} />,
    },
    {
      icon: <IconFeatureScalable className="block w-3 h-3" />,
      title: 'Scalable',
      image: <Image src="https://front.com/webassets/rebrand/usecase-client-comm-scalable.png" width={1300} height={733} alt="Front Admin Experience" quality={100} />,
    },
    {
      icon: <IconFeatureInsightful className="block w-3 h-3" />,
      title: 'Insightful',
      image: <Image src="https://front.com/webassets/rebrand/use-case-reporting-static.png" width={1300} height={733} alt="Front Reporting" quality={100} />,
    },
  ],
} as UseCaseFeatureCarouselProps;

export const HOME_PAGE_CAROUSEL_PROPS = {
  features: [
    {
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path d="M22.5 11.9995H16.5L14.5 14.9995H10.5L8.5 11.9995H2.5" stroke="#D0C6F0" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.95 5.11024L2.5 12.0002V18.0002C2.5 18.5307 2.71071 19.0394 3.08579 19.4145C3.46086 19.7895 3.96957 20.0002 4.5 20.0002H20.5C21.0304 20.0002 21.5391 19.7895 21.9142 19.4145C22.2893 19.0394 22.5 18.5307 22.5 18.0002V12.0002L19.05 5.11024C18.8844 4.77703 18.6292 4.49662 18.313 4.30052C17.9967 4.10443 17.6321 4.00044 17.26 4.00024H7.74C7.36792 4.00044 7.00327 4.10443 6.68705 4.30052C6.37083 4.49662 6.11558 4.77703 5.95 5.11024Z" stroke="#D0C6F0" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>,
      title: 'Shared Inbox',
      image: <AnimationSharedInbox playing />,
    },
    {
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M2.40039 5.6001H21.6004V8.82847C20.2435 9.02256 19.2004 10.1895 19.2004 11.6001C19.2004 13.0107 20.2435 14.1776 21.6004 14.3717V17.6001H2.40039V14.3717C3.7573 14.1776 4.80039 13.0107 4.80039 11.6001C4.80039 10.1895 3.7573 9.02256 2.40039 8.82847V5.6001Z" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.5996 6.3999V17.5999" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>,
      title: 'Ticketing',
      image: <AnimationTicketing playing />,
    },
    {
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path d="M14.0085 7.69101C15.613 9.29545 17.6884 10.3989 20.2424 11.0562C20.2442 11.0713 20.2452 11.0877 20.2452 11.1049C20.2452 11.1221 20.2442 11.1385 20.2424 11.1536C17.6884 11.8109 15.613 12.9143 14.0085 14.5188C12.4041 16.1232 11.3006 18.1986 10.6433 20.7526C10.6282 20.7545 10.6118 20.7555 10.5946 20.7555C10.5774 20.7555 10.561 20.7545 10.5459 20.7526C9.88864 18.1986 8.7852 16.1232 7.18075 14.5188C5.57631 12.9143 3.50089 11.8109 0.946875 11.1536C0.945061 11.1385 0.944015 11.1221 0.944015 11.1049C0.944015 11.0877 0.945057 11.0713 0.946871 11.0562C3.50088 10.3989 5.57631 9.29545 7.18075 7.69101C8.7852 6.08657 9.88864 4.01114 10.5459 1.45713C10.561 1.45532 10.5774 1.45427 10.5946 1.45427C10.6118 1.45427 10.6282 1.45531 10.6433 1.45712C11.3006 4.01114 12.4041 6.08656 14.0085 7.69101Z" stroke="#D0C6F0" strokeWidth="1.09701" />
      </svg>,
      title: 'AI Agent',
      image: <AnimationAiAgentsV2 playing />,
    },
    {
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path d="M13.5 1.99927L3.5 13.9993H12.5L11.5 21.9993L21.5 9.99927H12.5L13.5 1.99927Z" stroke="#D0C6F0" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>,
      title: 'Automation',
      image: <AnimationWorkflows playing />,
    },
    {
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M21.2104 15.8898C20.5742 17.3943 19.5792 18.7201 18.3123 19.7511C17.0454 20.7822 15.5452 21.4873 13.9428 21.8046C12.3405 22.122 10.6848 22.042 9.12055 21.5716C7.55627 21.1013 6.13103 20.2549 4.96942 19.1065C3.80782 17.9581 2.94522 16.5426 2.45704 14.9838C1.96886 13.425 1.86996 11.7703 2.169 10.1645C2.46804 8.55862 3.1559 7.05046 4.17245 5.77186C5.189 4.49327 6.50329 3.48315 8.00041 2.82983" stroke="#D0C6F0" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M22.001 12.0002C22.001 10.687 21.7423 9.38667 21.2398 8.17341C20.7372 6.96015 20.0006 5.85776 19.072 4.92918C18.1435 4.00059 17.0411 3.264 15.8278 2.76145C14.6146 2.2589 13.3142 2.00024 12.001 2.00024V12.0002H22.001Z" stroke="#D0C6F0" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>,
      title: 'Insights',
      image: <AnimationInsights playing />,
    },
  ],
} as UseCaseFeatureCarouselProps;

export const INTELLIGENCE_PROPS = {
  title: <span>AI-powered for instant resolutions and a helping hand for your team</span>,
  description: 'Front’s powerful, practical AI features provide end-to-end support. From instant self-serve answers to real-time agent assistance, Front Intelligence has your back.',

  media: (
    <div className="lg:aspect-[1024/576] rounded-10 overflow-hidden">
      <Image className="block w-full lg:hidden" src="https://front.com/webassets/rebrand/use-case-ai-powered-instant-resolution.png" width={1024} height={697} alt="AI-Powered Instant Resolution" />
      <video controls={false} playsInline autoPlay muted loop className="w-full hidden lg:block">
        <source src="https://front.com/webassets/pages/use-cases/front-omnichannel-support-use-case-ai.mp4" type="video/mp4" />
      </video>
    </div>
  ),

  links: [
    {
      type: 'primary',
      title: 'Request a demo',
      href: '',
      action: 'demo',
    },
    {
      type: 'secondary',
      title: 'Try for free',
      href: '',
      action: 'trial',
    },
  ],
} as UseCaseIntelligenceProps;

export const FEATURE_GRID_PROPS = {
  title: 'The collaborative platform for exceptional service',
  description:
    'A full suite of powerful features to help your team work together and stand out from the crowd',

  features: [
    {
      icon: (
        <Image src="https://front.com/webassets/rebrand/hp-feature-chat.svg" width={32} height={32} alt="Feature Icon Chat" className="block" />
      ),
      cta: {
        title: 'Chat',
        href: 'https://front.com/product/live-chat',
      },
      description: 'Help customers in-the-moment with live chat and AI bots',
    },
    {
      icon: (
        <Image src="https://front.com/webassets/rebrand/hp-feature-ai-answers.svg" width={32} height={32} alt="Feature Icon AI" className="block" />
      ),
      cta: {
        title: 'AI Answers',
        href: 'https://front.com/product/ai',
      },
      description: 'Deliver instant resolutions via chat when customers need it most',
    },
    {
      icon: (
        <Image
          src="https://front.com/webassets/rebrand/hp-feature-workflows.svg"
          width={32}
          height={32}
          alt="Feature Icon Workflows"
          className="block"
        />
      ),
      cta: {
        title: 'Workflows',
        href: 'https://front.com/product/workflows',
      },
      description: 'Build powerful automations that codify your team’s best practices',
    },
    {
      icon: (
        <Image
          src="https://front.com/webassets/rebrand/hp-feature-knowledge-base.svg"
          width={32}
          height={32}
          alt="Feature Icon Knowledge Base"
          className="block"
        />
      ),
      cta: {
        title: 'Knowledge Base',
        href: 'https://front.com/product/knowledge-base',
      },
      description: 'Document answers for faster, more accurate replies',
    },
    {
      icon: (
        <Image
          src="https://front.com/webassets/rebrand/hp-feature-tickets.svg"
          width={32}
          height={32}
          alt="Feature Icon Ticketing"
          className="block"
        />
      ),
      cta: {
        title: 'Ticketing',
        href: 'https://front.com/product/ticketing',
      },
      description: 'Resolve complex, nested issues requiring multiple teams',
    },
    {
      icon: (
        <Image
          src="https://front.com/webassets/rebrand/hp-feature-integrations.svg"
          width={32}
          height={32}
          alt="Feature Icon Integrations"
          className="block"
        />
      ),
      cta: {
        title: 'Integrations',
        href: 'https://front.com/integrations',
      },
      description: 'Power workflows across multiple systems',
    },
    {
      icon: (
        <Image
          src="https://front.com/webassets/rebrand/hp-feature-omnichannel.svg"
          width={32}
          height={32}
          alt="Feature Icon Omnichannel Inbox"
          className="block"
        />
      ),
      cta: {
        title: 'Omnichannel',
        href: 'https://front.com/product/omnichannel-inbox',
      },
      description: 'Connect voice, WhatsApp, SMS and more',
    },
    {
      icon: (
        <Image
          src="https://front.com/webassets/rebrand/hp-feature-analytics.svg"
          width={32}
          height={32}
          alt="Feature Icon Analytics"
          className="block"
        />
      ),
      cta: {
        title: 'Analytics',
        href: 'https://front.com/product/analytics',
      },
      description: 'Get powerful insights to keep evolving your product and services',
    },
  ],
} as UseCaseFeatureGridProps;

export const INTEGRATIONS_PROPS = {
  title: <span>We connect to the tools your team relies on</span>,
  description:
    'Reduce context switching and power workflow automations with 100+ out-of-the-box integrations. Don’t see your system? Build a no-code integration directly in Front.',

  media: (
    <Image
      className="block w-full"
      src="https://front.com/webassets/rebrand/use-case-integrations.png"
      width={2696}
      height={1406}
      alt="Front Integrations"
    />
  ),
  dropShadow: (
    <Image
      className="block w-full"
      src="https://front.com/webassets/rebrand/ellipse-background.png"
      width={2442}
      height={1330}
      alt="dropshadow"
    />
  ),
  links: [
    {
      type: 'secondary',
      title: 'View all integrations',
      href: 'https://front.com/integrations',
    },
  ],
  showButton: true,
} as UseCaseIntegrationsProps;

export const AWARDS_PROPS = {
  subtitle: 'Do unto others',
  title: 'Don’t settle for vendors with vague numbers. We put it all out Front.',
  description: 'We’re so confident you’ll love our award-winning Support team, we share our metrics publicly, in real-time.',
  featuredMetricTitle: '98%',
  featuredMetricSubtitle: 'CSAT Score',
  featuredMetricDescription: 'We’re so proud of our support, we publish our metrics in real time.',

  featuredMetricCta: {
    title: "Front's Support Report",
    href: 'https://front.com/support-report',
  },

  featuredAwards: [
    {
      image: (
        <Image
          key="badge-1"
          width={124}
          height={124}
          src="https://front.com/webassets/rebrand/award-remote-tech-breakthrough.png"
          className="block w-[83px] h-[83px] md:w-[124px] md:h-[124px]"
          alt="Customer Award Remote Tech Customer Service Excellence"
        />
      ),
      title: 'Customer Service Excellence',
    },
    {
      image: (
        <Image
          key="badge-2"
          width={124}
          height={124}
          src="https://front.com/webassets/rebrand/award-customer-happiness-2021.png"
          className="block w-[83px] h-[83px] md:w-[124px] md:h-[124px]"
          alt="Customer Award 2021 Customer Happiness"
        />
      ),
      title: 'Customer Happiness',
    },
    {
      image: (
        <Image
          key="badge-3"
          width={124}
          height={124}
          src="https://front.com/webassets/rebrand/award-top-customer-service-stevie-award.png"
          className="block w-[83px] h-[83px] md:w-[124px] md:h-[124px]"
          alt="Customer Award Stevie 2024 For Sales and Customer Service"
        />
      ),
      title: 'Top Customer Service Award',
    },
    {
      image: (
        <Image
          key="badge-4"
          width={124}
          height={124}
          src="https://front.com/webassets/rebrand/award-leading-customer-satisfaction-stevie-award.png"
          className="block w-[83px] h-[83px] md:w-[124px] md:h-[124px]"
          alt="Customer Award Stevie 2024 American Business"
        />
      ),
      title: 'Leading Customer Satisfaction',
    },
  ],

  awards: [
    <Image
      key="badge-1"
      width={83}
      height={107}
      src="https://front.com/webassets/rebrand/g2-front-best-usability-fall-2024.svg"
      className="block w-[83px] md:w-[94px] h-auto"
      alt="g2-front-best-usability-fall-2024"
    />,
    <Image
      key="badge-2"
      width={83}
      height={107}
      src="https://front.com/webassets/rebrand/g2-front-most-implementable-fall-2024.svg"
      className="block w-[83px] md:w-[94px]"
      alt="g2-front-most-implementable-fall-2024"
    />,
    <Image
      key="badge-3"
      width={83}
      height={107}
      src="https://front.com/webassets/rebrand/g2-front-highest-user-adoption-fall-2024.svg"
      className="block w-[83px] md:w-[94px]"
      alt="g2-front-highest-user-adoption-fall-2024"
    />,
    <Image
      key="badge-4"
      width={83}
      height={107}
      src="https://front.com/webassets/rebrand/g2-front-leader-fall-2024.svg"
      className="block w-[83px] md:w-[94px]"
      alt="g2-front-leader-fall-2024"
    />,
    <Image
      key="badge-5"
      width={83}
      height={107}
      src="https://front.com/webassets/rebrand/g2-front-momentum-leader-fall-2024.svg"
      className="block w-[83px] md:w-[94px]"
      alt="g2-front-momentum-leader-fall-2024"
    />,
  ],
} as UseCaseAwardsProps;
